import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import CheckBoxFormik from "../../../../components/UI/Checkbox/CheckBoxFormik";

const FormAtividadesAR = ({ formik }) => {
  const incisos = [
    {
      codigo: "I",
      descricao: "I - evidentes indícios de que os documentos fiscais não refletem o valor real das operações.",
    },
    {
      codigo: "II",
      descricao:
        "II - declaração, nos documentos fiscais, de valores notoriamente inferiores ao preço corrente das mercadorias, " +
        "ressalvados os casos de faturamento de operações a termo, sujeito à devida comprovação.",
    },
    {
      codigo: "III",
      descricao:
        "III - não exibição, aos agentes do fisco, dos livros fiscais ou da contabilidade geral, ou sua apresentação sem que estejam " +
        "devidamente escriturados, bem como dos documentos que comprovem o registro ou lançamento em livro fiscal ou contábil, do valor " +
        "das operações, inclusive sob alegação de perda, extravio, desaparecimento ou sinistro dos mesmos.",
    },
    {
      codigo: "IV",
      descricao:
        " IV - quando, em virtude de levantamento do movimento da conta mercadoria do exercício comercial, for apurado índice " +
        "operacional inferior ao valor agregado admissível.",
    },
    {
      codigo: "V",
      descricao: "V - armazenamento de mercadorias desacompanhadas de documentos fiscais.",
    },
    {
      codigo: "VI",
      descricao:
        "VI - utilização irregular de sistema eletrônico de processamento de dados, processo mecanizado, máquina registradora, " +
        "equipamento emissor de cupom fiscal (ECF) ou terminal ponto de venda (PDV), inclusive na condição de emissor autônomo, " +
        "de que resulte redução ou omissão do imposto devido, inclusive no caso de falta de apresentação do equipamento.",
    },
    {
      codigo: "VII",
      descricao: "VII - transporte desacompanhado dos documentos fiscais ou acompanhado de documentação inidônea.",
    },
    {
      codigo: "VIII",
      descricao:
        "VIII - utilização de regime especial de escrituração e tributação em desobediência às normas que o regem.",
    },
    {
      codigo: "IX",
      descricao:
        "IX - qualquer outro caso em que se comprove a sonegação do imposto, e o fisco não possa conhecer o montante sonegado.",
    },
  ];

  const changeHandler = (event) => {
    const updatedIncisos = [...formik.values.txParametrizacao];
    if (event.target.checked && updatedIncisos.indexOf(event.target.id) === -1) {
      updatedIncisos.push(event.target.id);
    } else {
      updatedIncisos.splice(updatedIncisos.indexOf(event.target.id), 1);
    }
    formik.setFieldValue("txParametrizacao", updatedIncisos);
  };

  return (
    <>
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <CheckBoxFormik formik={formik} field="fgAnexoBo" label="Cópia do Boletim de Ocorrência" />
          <CheckBoxFormik formik={formik} field="fgAnexoJornal" label="Cópia do Jornal de Publicação" />
        </Form.Group>
      </Row>
      <Form.Label>
        <b>Motivo do Arbitramento</b>
      </Form.Label>
      {incisos.map((item) => (
        <Form.Check
          key={item.codigo}
          type="checkbox"
          id={item.codigo}
          name="txParametrizacao"
          label={item.descricao}
          disabled={formik.isSubmitting}
          onChange={(event) => changeHandler(event)}
          defaultChecked={!!formik.values.txParametrizacao.find((element) => element === item.codigo)}
        />
      ))}
      {formik.errors.txParametrizacao && (
        <Form.Control.Feedback type="invalid">{formik.errors.txParametrizacao}</Form.Control.Feedback>
      )}
      <br />
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <Form.Label>
            <b>Fatos justificadores:</b>
          </Form.Label>
          <HtmlEditor formik={formik} field="txJustificativa" rows="4" />
        </Form.Group>
      </Row>
    </>
  );
};

export default FormAtividadesAR;
